import { render, staticRenderFns } from "./amazonadvertisment.vue?vue&type=template&id=8d1b824c"
import script from "./amazonadvertisment.vue?vue&type=script&lang=js"
export * from "./amazonadvertisment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports